import { useEffect, useState } from 'react'
import { search as searchFinalGrade } from 'store/attendance/final-grades'
import Header from 'components/Header'
import { BasePathProvider, useBasePath, useSession } from 'components/Providers'
// import { useParams } from 'react-router-dom'
import FinalGradeList from './FinalGradeList'
import { useSelector, useDispatch } from 'react-redux'
import { Typography } from '@mui/material'
import { LinearProgress } from '@mui/material'
import NotFound from 'components/NotFound'

export default function FinalGrade({ selectedCourseSession }) {
  const dispatch = useDispatch()
  const basePath = useBasePath()
  const { academicYear } = useSession()
  // const { courseSessionId } = useParams()
  const [notFound, setNotFound] = useState(false)
  console.log(selectedCourseSession)
  // const selectedCourseSession = useSelector((state) => state.academic.courseSession.selectedCourseSession);

  useEffect(() => {
      dispatch(searchFinalGrade({ courseSessionId: selectedCourseSession.id })).then(res => {
        res.error && setNotFound(true)
      })
  }, [ dispatch, selectedCourseSession])

  const finalGrades = useSelector(state => state.attendance.finalGrades.list)

  const markingPeriods = academicYear.markingPeriods

  if (notFound) return <NotFound basePath={basePath} />

  if (!finalGrades?.length || !markingPeriods?.length) return <LinearProgress sx={{ m: 2 }} color="success" />

  return (
    <BasePathProvider value={`${basePath}/final-grade`}>
      <Header title={'Final Grade'} small />
      <Typography sx={{ marginLeft: '15px' }} gutterBottom variant={'h7'}>
        {`Number of registered students : ${finalGrades?.length}`}
      </Typography>
      {finalGrades && markingPeriods && <FinalGradeList datas={finalGrades} markingPeriods={markingPeriods} />}
    </BasePathProvider>
  )
}
